const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

async function apiRequest(url, options = {}) {
  let token = localStorage.getItem("accessToken");

  const res = await fetch(`${API_BASE_URL}${url}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
      Authorization: token ? `Bearer ${token}` : "",
    },
  });

  // 🔥 HANDLE TOKEN EXPIRY
  if (res.status === 401) {
    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
      window.location.href = "/";
      return;
    }

    const refreshRes = await fetch(`${API_BASE_URL}/auth/refresh-token`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ refreshToken }),
    });

    const refreshData = await refreshRes.json();

    if (!refreshRes.ok) {
      localStorage.clear();
      window.location.href = "/";
      return;
    }

    localStorage.setItem("accessToken", refreshData.accessToken);

    // retry original request
    return fetch(`${API_BASE_URL}${url}`, {
      ...options,
      headers: {
        ...(options.headers || {}),
        Authorization: `Bearer ${refreshData.accessToken}`,
      },
    }).then(r => r.json());
  }

  return res.json();
}

export default apiRequest;